<div class="tw-w-[90%] tw-m-auto tw-my-4">
    <div>
        <mat-card>
            <mat-card-content class="tw-flex tw-justify-between">
                <div class="tw-grid tw-grid-flow-col tw-gap-2">
                    <button
                        mat-raised-button
                        mwlCalendarPreviousView
                        [view]="view"
                        [(viewDate)]="viewDate"
                        (click)="updateCalendarEvents(viewRender, true)"
                    >
                        Previous
                    </button>
                    <button
                        mat-flat-button
                        mwlCalendarToday
                        [(viewDate)]="viewDate"
                        (click)="updateCalendarEvents(viewRender, true)"
                    >
                        Today
                    </button>
                    <button
                        mat-raised-button
                        mwlCalendarNextView
                        [view]="view"
                        [(viewDate)]="viewDate"
                        (click)="updateCalendarEvents(viewRender, true)"
                    >
                        Next
                    </button>
                </div>

                <div class="tw-ml-auto tw-flex tw-items-start tw-gap-4">
                    <form>
                        <mat-form-field style="width: 470px">
                            <mat-label>Filter User</mat-label>

                            <mat-chip-grid
                                #chipGrid
                                aria-label="Name selection"
                                selectable="false"
                            >
                                @for (user of selectedUsers(); track $index) {
                                    <mat-chip-row (removed)="remove(user)">
                                        {{
                                            user.firstName + " " + user.lastName
                                        }}
                                        <button
                                            matChipRemove
                                            [attr.aria-label]="'remove ' + user"
                                        >
                                            <mat-icon>cancel</mat-icon>
                                        </button>
                                    </mat-chip-row>
                                }

                                <input
                                    placeholder="New User..."
                                    name="currentName"
                                    #userInput
                                    [(ngModel)]="currentUser"
                                    [matChipInputFor]="chipGrid"
                                    [matAutocomplete]="auto"
                                    [matChipInputSeparatorKeyCodes]="
                                        separatorKeysCodes
                                    "
                                    (matChipInputTokenEnd)="add($event)"
                                />
                            </mat-chip-grid>

                            <mat-autocomplete
                                #auto="matAutocomplete"
                                [autoActiveFirstOption]="false"
                                (optionSelected)="
                                    selected($event); userInput.value = ''
                                "
                            >
                                @for (user of filteredUsers(); track user) {
                                    <mat-option [value]="user">
                                        {{
                                            user.firstName + " " + user.lastName
                                        }}
                                    </mat-option>
                                }
                            </mat-autocomplete>
                        </mat-form-field>
                    </form>

                    <button (click)="openTimeOffManager()" mat-raised-button>
                        View My Time Off
                    </button>
                </div>
            </mat-card-content>
        </mat-card>

        <h2>{{ viewDate | calendarDate: view + "ViewTitle" : "en" }}</h2>
    </div>

    <div
        [ngClass]="{
            dark: (getTheme$() | async) === 'dark-theme',
            light: (getTheme$() | async) === 'light-theme'
        }"
    >
        <mwl-calendar-month-view
            [viewDate]="viewDate"
            [events]="calendarEvents"
            [refresh]="refresh"
            [activeDayIsOpen]="activeDayIsOpen"
            (beforeViewRender)="updateCalendarEvents($event)"
            (dayClicked)="dayClicked($event.day)"
            [cellTemplate]="customCellTemplate"
        ></mwl-calendar-month-view>
    </div>

    <ng-template #customCellTemplate let-day="day" let-locale="locale">
        <div
            class="custom-day-cell"
            [ngClass]="{
                'tw-cursor-pointer': day.events.length > 0
            }"
        >
            <div class="cal-cell-top">
                <span
                    class="cal-day-badge"
                    *ngIf="
                        day.badgeTotal > 0 &&
                        !nonShowingDays.includes(day.date.getDay())
                    "
                >
                    {{ day.badgeTotal }}
                </span>
                <span class="cal-day-number">
                    {{ day.date | calendarDate: "monthViewDayNumber" : locale }}
                </span>
            </div>

            <div
                *ngIf="
                    day.badgeTotal > 0 &&
                    !nonShowingDays.includes(day.date.getDay())
                "
            >
                <div *ngFor="let event of day.events; index as i">
                    <div
                        *ngIf="
                            i < eventLimit &&
                            event.userName.length > 0 &&
                            event.title == undefined
                        "
                    >
                        {{ event.userName + " - " + event.timeOffDescription }}
                    </div>

                    <div
                        *ngIf="
                            i < eventLimit &&
                            event.userName.length > 0 &&
                            event.title != undefined
                        "
                    >
                        {{ event.userName + " - " + event.title }}
                    </div>

                    <div *ngIf="i < eventLimit && event.userName.length <= 0">
                        {{ event.title }}
                    </div>

                    <div *ngIf="i === eventLimit">
                        {{ day.events.length - eventLimit }} More
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>
